import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import addProduct from "../utils/addProducts.png";
import deleteIcon from "../utils/delete.png";
import Tooltip from "@mui/material/Tooltip";
import notAllowedSymbol from "../utils/notAllowedSymbol.svg";

const ProductsInfo = ({
  productEntryInAllEntries,
  clearProductsList,
  setProductEntries,
  productEntries,
  handleAddRow,
  handleInputChange,
  selectProduct,
  currentProductEntryRowId,
  productData,
  setCurrentF2ItemForSearchPopup
}) => {
  const [selectedRows, setSelectedRows] = useState([]);

  const [isSelectedItemCodeCorrect, setIsSelectedItemCodeCorrect] =
    useState(false);

  const toggleSelectAll = () => {
    if (selectedRows?.length === productEntries?.length) {
      setSelectedRows([]); // Unselect all if all are selected
    } else {
      setSelectedRows(productEntries?.map((_, index) => index)); // Select all rows
    }
  };

  // Toggle selection of a row
  const toggleRowSelection = (index) => {
    setSelectedRows(
      (prevSelectedRows) =>
        prevSelectedRows.includes(index)
          ? prevSelectedRows.filter((i) => i !== index) // Remove if already selected
          : [...prevSelectedRows, index] // Add if not selected
    );
  };

  // Delete selected rows
  const deleteSelectedRows = () => {
    const updatedEntries = productEntries.filter(
      (_, index) => !selectedRows.includes(index)
    );
    setProductEntries(updatedEntries);
    setSelectedRows([]); // Clear selection after deletion
  };

  const productsWithImage = productData?.filter(
    (prod) => prod.Imagepath !== ""
  );
  const imagePaths = productsWithImage?.map((prod) => prod.Imagepath);
  // console.log('productsWithImage',productsWithImage)
  // console.log('imagePaths',imagePaths)

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
  const getStyleOfChip = () => {
    return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset"
  }

  const fetchItemImage = (itemFilePath) => {
    if (!itemFilePath) return ""; // Handle missing image

    // Extract file name from the full path
    const extractedFileName = itemFilePath.split("BONDTIME_PRODUCT_IMG\\")[1];

    // Construct the correct URL for the image
    return `https://sunrise.dyndns-server.com:92/BONDTIME_PRODUCT_IMG/${extractedFileName}`;
  };

  return (
    <div className="productsContainer rounded py-4  min-h-[300px]">

      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-thin">Products Of Interest</h2>
        <div className="flex gap-2">
          <button className="p-2" onClick={(e) => handleAddRow(e)}>
            <img src={addProduct} alt="addProduct-icon" className="w-4 h-4" />
          </button>
          {/* <button
            className={`p-2 ${selectedRows?.length === 0 ? "invisible" : ""}`}
            onClick={(e)=>handleDeleteSelected(e)}
          >
            <img src={deleteIcon} alt="delete-icon" className="w-4 h-4" />
          </button> */}
        </div>
      </div>
      <div className="overflow-x-auto min-h-[220px]">
        {selectedRows?.length > 0 && (
          <button
            onClick={deleteSelectedRows}
            disabled={selectedRows?.length === 0}
            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 mb-2"
          >
            Delete Selected
          </button>
        )}
        <table className="min-w-full bg-white border border-gray-300   ">
          <thead className="">
            <tr className="bg-gray-200  rounded">
              <th className="border px-2 py-1 text-center">
                <input
                  className="rounded border border-sm shadow"
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    selectedRows?.length === productEntries?.length &&
                    productEntries?.length > 0
                  }
                />
              </th>
              <th className="px-1 py-0.5 font-normal border">Item Code</th>
              <th className="px-1 py-0.5 font-normal w-[300px]  border">
                Description
              </th>
              <th className="px-1 py-0.5 font-normal border">Image</th>
              <th className="px-1 py-0.5 font-normal border">Unit</th>
              <th className="px-1 py-0.5 font-normal border">Curr Stock</th>
              <th className="px-1 py-0.5 font-normal border">Qty</th>
              <th className="px-1 py-0.5 font-normal border">Price</th>
              <th className="px-1 py-0.5 font-normal border">Amnt</th>
            </tr>
          </thead>

          <tbody>
            {productEntries?.map((row, index) => (
              <tr key={index} className="text-sm">

                {console.log("productEntries in tabel: currentProductEntryRowId", productEntries, currentProductEntryRowId)}

                <td className=" border w-[20px]  text-center">
                  <input
                    type="checkbox"
                    className="rounded border border-sm shadow"
                    checked={selectedRows.includes(index)}
                    onChange={() => toggleRowSelection(index)}
                  />
                </td>

                <td className=" border relative w-[150px]">
                  {/* <Tooltip title={row.itemCode} arrow> */}
                    <input
                    autoComplete="off"
                      onFocus={(e) => { setCurrentF2ItemForSearchPopup(row); setShowDropdown(true) }}
                      type="text"
                      name="itemcode"
                      id={row.Lead_ID || row.id}
                      value={row.Prod_code || row.itemCode}
                      onChange={(e) =>
                        handleInputChange(row.id, "itemCode", e.target.value)
                      }
                      placeholder="Enter Item Code"
                      // list={`itemCodes-${row.id}`} // Unique list for each row
                      className={`w-full border-none p-1 font-normal text-sm focus:outline-none focus:ring-0 ${row.itemCode?.length > 0
                        ? row.isSelectedItemCodeCorrect
                          ? "bg-transparent"
                          : "bg-red-400"
                        : "bg-transparent"
                        }  `}
                    // onFocus={() => setShowDropdown(true)}
                    // onBlur={() => console.log('clicked outside input')}
                    />

                    {currentProductEntryRowId === row.id &&
                      showDropdown &&
                      productData &&
                      row.itemCode?.length > 0 && (
                        <div
                          ref={dropdownRef}
                          style={{ width: "60rem" }}
                          className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300"
                        >
                          {productData
                            ?.filter((product) => product.Code) // Filter matching products
                            ?.map((product, index) => (
                              <div
                                onClick={() => selectProduct(product.Code)}
                                key={index}
                                className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                              >
                                <p className="font-semibold">{product.Code}</p>
                                <p className="text-xs text-gray-500">
                                  {product.Description}
                                </p>
                                <div>
                                    <span className={getStyleOfChip()}>
                                      Group: {product.Group}
                                    </span>
                                    <span className={getStyleOfChip()}>
                                      Subgroup: {product.Sgroup}
                                    </span>
                                    <span className={getStyleOfChip()}>
                                      Stock: {product.Stock}
                                    </span>
                                    <span className={getStyleOfChip()}>
                                      Ord Pending: {product.Ord_Pend}
                                    </span>
                                    <span className={getStyleOfChip()}>
                                      PO Pending: {product.Po_Pend}
                                    </span>
                                    <span className={getStyleOfChip()}>
                                      Selprice: {product.SelPrice}
                                    </span>
                                  </div>
                              </div>
                            ))}
                        </div>
                      )}
                  {/* </Tooltip> */}
                </td>

                <Tooltip
                  title={row.Prod_Description || row.itemDescription}
                  arrow
                >
                  <td className=" border ">
                    <input

                      type="text"
                      id={row.Lead_ID || row.id}
                      value={row.Prod_Description || row.itemDescription}
                      onChange={(e) =>
                        handleInputChange(
                          row.id,
                          "itemDescription",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border-none text-xs font-thin focus:outline-none focus:ring-0 text-left"
                    />
                  </td>
                </Tooltip>

                {/* <td className=" border w-[70px] text-center">
                  <input
                    type="text"
                    value={row.itemImage}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemImage", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td> */}

                <td className="border w-[70px] text-center p-1">
                  <div className="flex justify-center items-center h-full">
                    {row.itemImage ? (
                      <img
                        src={fetchItemImage(
                          row.prod_imagepath || row.itemImage
                        )}
                        alt="Product"
                        className="w-6 h-6 object-cover rounded-md mx-auto"
                      />
                    ) : (
                      <img
                        // onClick={() => handleOpenModal(stock.CODE)}
                        src={notAllowedSymbol}
                        alt="Upload"
                        className="w-6 h-6 object-cover border rounded-md"
                      />
                    )}
                  </div>
                </td>

                <td className=" border w-[70px] text-center">
                  <input
                    type="text"
                    value={row.Prod_Unit || row.itemUnit}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemUnit", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td>
                <td className=" border w-[80px] text-center">
                  {/* <input
                    type="text"
                    value={row.itemCurrentStock}
                    onChange={(e) =>
                      handleInputChange(
                        row.id,
                        "itemCurrentStock",
                        e.target.value
                      )
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  /> */}
                  {Number(row.itemCurrentStock) == 0 && row.itemCurrentStock != "" ?
                    <div style={{ backgroundColor: "#f00", padding: "6px" }}>
                      {
                        row.itemCurrentStock
                      }
                    </div>
                    :
                    <div style={{ backgroundColor: "#f7f7f7", padding: "6px" }}>
                      {
                        row.itemCurrentStock
                      }
                    </div>
                  }

                </td>
                <td className=" border w-[40px]">
                  <input
                    type="text"
                    value={row.Prod_Qty || row.itemQuantity}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemQuantity", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td>
                <td className=" border w-[40px]">
                  <input
                    type="text"
                    value={row.Prod_Price || row.itemPrice}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemPrice", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td>
                <td className=" border w-[30px] text-center">
                  <input
                    type="text"
                    value={
                      row.itemQuantity == ""
                        ? "-/-"
                        : row.Prod_Qty * row.Prod_Price ||
                        row.itemQuantity * row.itemPrice
                    }
                    readOnly
                    className="w-full p-0 border-none cursor-not-allowed focus:outline-none focus:ring-0 text-center"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="text-right gap-2">
          <button className="p-2" onClick={(e) => handleAddRow(e)}>
            <img src={addProduct} alt="addProduct-icon" className="w-4 h-4" />
          </button>
        </div>
      </div>



    </div>
  );
};

export default ProductsInfo;
